<template>
  <router-view></router-view>
</template>

<script>
import moment from 'moment';
export default {
  name: 'App',
}
</script>

<style lang="scss">
  // Import font awesome
  $fa-font-path: "~@fortawesome/fontawesome-pro/webfonts/";
  @import '~@fortawesome/fontawesome-pro/scss/fontawesome.scss';
  @import '~@fortawesome/fontawesome-pro/scss/regular.scss';
  @import '~@fortawesome/fontawesome-pro/scss/solid.scss';
  @import '~@fortawesome/fontawesome-pro/scss/light.scss';
  @import '~@fortawesome/fontawesome-pro/scss/brands.scss';
  @import '~@fortawesome/fontawesome-pro/scss/v4-shims.scss';
  // Import bootstrap
  @import '~bootstrap/scss/bootstrap';
  @import '~bootstrap-vue/src/index.scss';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
